if (!customElements.get("pin-scrub")) {
  class PinScrub extends HTMLElement {
    constructor() {
      super();
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.imageWraps = this.querySelectorAll('.pin-scrub__image');
      this.contentBlocks = this.querySelectorAll('.pin-scrub__text');
      window.addEventListener('scroll', this.onScroll);
      window.addEventListener('resize', this.onResize);
      document.addEventListener('DOMContentLoaded', this.onScroll);
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('DOMContentLoaded', this.onScroll);
    }

    onResize() {
      this.onScroll();
    }

    onScroll() {
      let activeIndex = 0;
      for (let i = 0; i < this.contentBlocks.length; i++) {
        const rect = this.contentBlocks[i].getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.5 && rect.bottom > window.innerHeight * 0.2) {
          activeIndex = i;
        }
      }
      this.imageWraps.forEach((img, idx) => {
        idx === activeIndex?img.classList.add('active'):img.classList.remove('active')
      });
    }
  }
  customElements.define("pin-scrub", PinScrub);
}